<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../assets/u3220.png" class="icon_img" />
          稿件录用率统计
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="8">
            <label>投稿日期：</label>
            <a-date-picker :value="leftDate" @change="leftDateChange" />
            <label style="padding: 10px">至</label>
            <a-date-picker :value="rightDate" @change="rightDateChange" />
          </a-col>
          <a-checkbox-group :options="statusList" v-model="selectedStatus" />
          <a-button type="primary" class="query_btn" @click="query"
            >查询</a-button
          >
        </a-row>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :columns="[
            {
              title: '投稿数量',
              dataIndex: 'manuscriptCount',
            },
            {
              title: '录用数量',
              dataIndex: 'employCount',
            },
            {
              title: '稿件录用率(%)',
              dataIndex: 'employRate',
            },
          ]"
          :dataSource="data"
          :rowKey="(record) => record.uId"
          size="small"
          bordered
        ></a-table>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
export default {
  name: "employRate",
  data() {
    return {
      data: [],
      leftDate: null,
      rightDate: null,
      beginTime: "",
      finishTime: "",
      statusList: [
        { label: "包括责编未收稿件", value: "1" },
        { label: "包含总编未签发刊次", value: "11" },
      ],
      selectedStatus: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "91",
        "99",
      ],
    };
  },
  computed: {},
  methods: {
    query() {
      this.axios
        .get("/statistical/employRate", {
          params: {
            beginTime: this.beginTime,
            finishTime: this.finishTime,
            statusList: this.selectedStatus.join(","),
            year: this.year,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.data = [];
          if (res.data != null) {
            this.data.push(res.data);
          } else {
            this.utils.messageInfo(this, "error", "查询稿件录用统计失败！");
          }
        });
    },
    leftDateChange(date, dateString) {
      this.beginTime = dateString;
      this.leftDate = date;
    },
    rightDateChange(date, dateString) {
      this.finishTime = dateString;
      this.rightDate = date;
    },
  },
  created() {
    const year = new Date().getFullYear();
    //第一天
    const queryDate = year + "-01-01";
    this.beginTime = queryDate;
    this.query();
  },
  mounted() {},
};
</script>

<style>
@import "../../../assets/css/PageCss.css";
</style>

